import { useEffect } from "react";
import Button from "../../Components/Button/Button";
import { dateAndTimeConverter } from "../../Utils/constants";

export default function ManualApprovalSuccess(props) {
  useEffect(() => {
    if (props.capturedPhoto === null || props.selectedEmployee === null) {
      props.navigate("/");
    }
    // eslint-disable-next-line
  }, [props.capturedPhoto, props.selectedEmployee]);

  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div className="font-size-medium  text-align-center ">
          Submitted for approval
        </div>

        <div className="wrapper padding-top-larger">
          <svg className="check_mark" viewBox="0 0 52 52">
            <circle
              className="check_mark_circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="check_mark_check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <div className="padding-top-larger text-align-center font-size-medium ">
          {`${props.selectedEmployee?.name || "N/A"}, ${
            props.selectedEmployee?.phoneNumber || "N/A"
          }`}
        </div>
        <div className="padding-top-default text-align-center font-size-medium ">
          {`Captured at ${props.location?.PCTNo || "N/A"} - ${
            props.location?.location || "N/A"
          }`}
        </div>
        <div className="padding-top-default text-align-center font-size-medium ">
          {`On ${dateAndTimeConverter(
            +new Date(),
            "secondDate"
          )}, ${dateAndTimeConverter(+new Date(), "Time")}`}
        </div>

        <div className="padding-top-default text-align-center font-size-small">
          Attendance will be provided once approved
        </div>
      </div>

      <Button
        data-cy="okay-button"
        type="button"
        text="Okay"
        boxShadow={false}
        onClick={() => {
          props.navigate("/");
        }}
      />
    </div>
  );
}
